import { useTranslation } from 'react-i18next';
import FeedbackSlider from './FeedbackSlider';

export default function Feedback() {
  const { t } = useTranslation('home');
  return (
    <div className="feedback lg:!py-[60px] sm:!py-10 !py-8">
      <div className="container">
        <h2 className="section-heading text-center mb-6 sm:mb-8 lg:mb-10">{t('feedback.heading')}</h2>

        <div className="feedback__wrap">
          <FeedbackSlider />
        </div>
      </div>
    </div>
  );
}
